/**
 * Centralized `data-action` identifiers.
 *
 * Notes:
 * - Keep values in sync with HTML `data-action` attributes.
 * - Do not change existing values casually (treat as public API).
 */

export class Actions {
    public static CLOSE = "close";
    public static CONFIRM = "confirm";
    public static CLEAR = "clear";

    public static CLEAR_ALL = "clear-all";

    public static CHOICES_CLEAR_ALL = "choices-clear-all";

    public static SELECT_RANK = "select-rank";
    public static SELECT_CLEAR = "select-clear";
    public static SELECT_CLEAR_ALL = "select-clear-all";

    public static SELECT_USER = "select-user";
    public static SELECT_CATEGORY = "select-category";
    public static SELECT_PARENT = "select-parent";
    public static SELECT_BRAND = "select-brand";

    public static CLEAR_PARENT = "clear-parent";

    public static RECOMMEND_CLOSE = "recommend-close";
    public static RECOMMEND_UNSET = "recommend-unset";
    public static RECOMMEND_RANK = "recommend-rank";

    public static EDIT = "edit";
    public static DELETE = "delete";
    public static REMOVE = "remove";

    public static SET_IMAGE_SIZE = "set-image-size";
    public static SET_IMAGE_FLOAT = "set-image-float";
}
